export interface PendingUser {
  email:string,
  name:string
}